"use strict";

import {IRootScopeService, IQService} from "angular";
import {CacheService} from "./CacheService";
import {ICachingTimesService} from "../providers/CachingTimesProvider";
import {CacheProxy} from "./CacheProxy";
import {Subscription} from "rxjs";
import {IApiUser, User} from "ng-league";
import {forEach} from "lodash";

export class UserCacheProxy extends CacheProxy {

    public static $inject = ["$rootScope", "$q", "CacheService", "UserResource", "CachingTimes"];
    constructor(
        protected $rootScope:IRootScopeService,
        protected $q:IQService,
        protected CacheService:CacheService,
        protected UserResource:any,
        protected CachingTimes:ICachingTimesService
    ) {
        super($q, $rootScope, CacheService);
    }

    /**
     * @param userId
     * @returns {string}
     */
    public getUserCacheKey(userId: string) {
        return `user:${userId}`;
    }

    /**
     * Cache Teams
     * @param users
     */
    public cacheUsers(users: any[]) {
        forEach(users, (user: IApiUser) => {
            let cacheKey = this.getUserCacheKey(user.id);
            this.CacheService.setItem(cacheKey, user, this.CachingTimes.getUserCacheTimeout());
        });
    }

    /**
     *
     * @param userIds
     * @param callback
     * @param fetch
     * @returns {Subscription}
     */
    public getUsers(userIds: string[], callback: Function, fetch: boolean = true): Subscription {
        if (fetch) {
            this.fetchAndCacheUncachedUsers(userIds);
        }

        let cacheKeys = userIds.map((userId:any) => {
            return this.getUserCacheKey(userId);
        });

        return this.getObservableFromKeys(cacheKeys, (user:IApiUser) => {
            return new User(user);
        }, callback);
    }

    /**
     * Fetch uncached users
     * @param userIds
     * @returns {Promise<User[]>}
     */
    public fetchAndCacheUncachedUsers(userIds: string[]) {
        return this.getUncachedItems(userIds, this.getUserCacheKey).then((ids: string[]) => {
            if (ids.length === 0) {
                return null;
            }

            return this.UserResource.getUsers(ids).then((users: IApiUser[]) => {
                let userObjects = [];

                forEach(users, (user: IApiUser) => {
                    let cacheKey = this.getUserCacheKey(user.id);
                    this.CacheService.setItem(cacheKey, user, this.CachingTimes.getUserCacheTimeout());
                    userObjects.push(new User(user));
                });

                return userObjects;
            });
        });
    }
}